module.exports = __webpack_public_path__ + "img/logo.8bdf59c6.svg";